import css from "styled-jsx/css";
import { MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export default css.global`
  .video-carousel-desktop-component {
    .video-carousel-title {
      margin-bottom: 48px;

      .colorful-title,
      .colored {
        font-size: 2.25rem;
        text-align: center;
        font-weight: 700;
      }
    }

    .stories-slick-carousel {
      @media (max-width: 650px) {
        // remove arrows
        margin-left: -14px;
        width: auto;
        .slick-slider {
          .slick-arrow {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .video-carousel-desktop-component {
      .items-without-carousel {
        flex-direction: column;
        overflow: hidden;

        .video-carousel-item-component {
          margin-bottom: 48px;
        }
      }
      .video-carousel-title {
        .colorful-title,
        .colored {
          font-size: 1.75rem;
        }
      }
    }
  }
`;
